// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3RBdx","title":"Header_title__3AqU3","left":"Header_left___yvx-","clinicName":"Header_clinicName__3b5Bs"};